/**
 * TaskToolbar — recherche + filtres (dossier · expertise · type · priorité · statut · échéance · année).
 */
import { Search, X } from "lucide-react";
import CollapsibleFilters from "@/components/shared/CollapsibleFilters";
import { FISCAL_YEARS } from "@/constants/modules";
import { inputCls } from "../comptabilite/_shared";
import { DUE_FILTERS, EXPERTISES, TASK_PRIORITIES, TASK_STATUSES, TASK_TYPES, masterLabel } from "./taskHelpers";

const sel = `${inputCls} w-auto py-1.5 text-xs`;

export default function TaskToolbar({ f, setF, masters, showStatus, count }) {
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const active = Object.entries(f).filter(([, v]) => v).length;
  const search = (
    <div className="relative flex-1 md:flex-none min-w-[160px]">
      <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
      <input value={f.q} onChange={set("q")} placeholder="Rechercher une tâche, une étape…" className={`${inputCls} pl-9 w-full md:w-64 py-1.5 text-xs`} data-testid="task-search" />
    </div>
  );
  return (
    <CollapsibleFilters active={active - (f.q ? 1 : 0)} always={search} className="bg-white border rounded-xl p-3" testId="task-toolbar">
      <select value={f.master_id} onChange={set("master_id")} className={`${sel} max-w-[220px]`} data-testid="task-filter-master">
        <option value="">Tous les dossiers</option>
        {masters.map((m) => <option key={m.id} value={m.id}>{masterLabel(m)}</option>)}
      </select>
      <select value={f.expertise} onChange={set("expertise")} className={sel} data-testid="task-filter-expertise">
        <option value="">Toutes les expertises</option>
        {EXPERTISES.map((e) => <option key={e.id} value={e.id}>{e.label}</option>)}
      </select>
      <select value={f.task_type} onChange={set("task_type")} className={sel} data-testid="task-filter-type">
        <option value="">Tous les types</option>
        {TASK_TYPES.map((t) => <option key={t.id} value={t.id}>{t.label}</option>)}
      </select>
      <select value={f.priority} onChange={set("priority")} className={sel} data-testid="task-filter-priority">
        <option value="">Toutes les priorités</option>
        {TASK_PRIORITIES.map((p) => <option key={p.id} value={p.id}>{p.label}</option>)}
      </select>
      {showStatus && (
        <select value={f.status} onChange={set("status")} className={sel} data-testid="task-filter-status">
          <option value="">Tous les statuts ouverts</option>
          {TASK_STATUSES.filter((s) => s.id !== "terminee").map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
        </select>
      )}
      <select value={f.due} onChange={set("due")} className={sel} data-testid="task-filter-due">
        {DUE_FILTERS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      <select value={f.tax_year} onChange={set("tax_year")} className={sel} data-testid="task-filter-year">
        <option value="">Toutes les années</option>
        {FISCAL_YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
      </select>
      <span className="md:ml-auto text-xs text-slate-500" data-testid="task-count">{count} tâche{count > 1 ? "s" : ""}</span>
      {active > 0 && (
        <button onClick={() => setF({ q: "", master_id: "", expertise: "", task_type: "", priority: "", status: "", due: "", tax_year: "" })}
          className="inline-flex items-center gap-1 text-xs text-rose-600 hover:underline" data-testid="task-reset-filters">
          <X className="w-3 h-3" /> Réinitialiser
        </button>
      )}
    </CollapsibleFilters>
  );
}
